export default __webpack_public_path__ + "static/media/swap-fees-header-m-bg.80d21263.png";